import { render, staticRenderFns } from "./PopupFiltersAboutProject.vue?vue&type=template&id=fbb72c20"
import script from "./PopupFiltersAboutProject.vue?vue&type=script&lang=ts"
export * from "./PopupFiltersAboutProject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports